/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { createAction, props } from '@ngrx/store';
import { ClusterId } from '@shared/types/cluster';
import { MetricDefinition } from '@shared/types/metrics';

export const metricDefsAction = createAction(
  '[Metric defs] Metric defs',
  props<{ clusterId: ClusterId; data: MetricDefinition[] }>(),
);
